import React from 'react';

import { ProvenienciaDoRadar } from '../../api/radarApi';
import { ComoFuncionaSecao } from '../como-funciona/ComoFunciona';

/**
 * O `?` de proveniência de um cartão de radar (transversal/at-82).
 *
 * 🔴 É a **única via de auditar o número**, e o texto é sempre do SISTEMA — nunca da IA. Estava
 * duplicado nas duas telas, com a diferença de que só o Financeiro trazia a seção "Como conferir".
 * Aqui ela é opcional por parâmetro, em vez de justificar uma segunda cópia da função.
 *
 * @param comoConferir Texto da seção final. Ausente = a seção não aparece (o Radar do
 *   Relacionamento não tem tela vizinha onde conferir o mesmo recorte).
 */
export function secoesDaProveniencia(
  proveniencia: ProvenienciaDoRadar,
  comoConferir?: React.ReactNode,
): ComoFuncionaSecao[] {
  const secoes: ComoFuncionaSecao[] = [
    {
      titulo: 'A regra usada',
      conteudo: <p>{proveniencia.regra}</p>,
    },
    {
      titulo: 'De onde vem o dado',
      conteudo: (
        <ul>
          {proveniencia.fontes.map((fonte) => (
            <li key={fonte}>
              <span className="do-codigo">{fonte}</span>
            </li>
          ))}
        </ul>
      ),
    },
    {
      titulo: 'O que este número não diz',
      conteudo: (
        <ul>
          {proveniencia.limitacoes.map((limitacao) => (
            <li key={limitacao}>{limitacao}</li>
          ))}
        </ul>
      ),
    },
  ];

  if (comoConferir) {
    secoes.push({ titulo: 'Como conferir', conteudo: <p>{comoConferir}</p> });
  }

  return secoes;
}
